import { createFileRoute } from '@tanstack/react-router'

import { ForgotPasswordPage } from '@/pages/forgot-password/page'

export const Route = createFileRoute('/forgot-password')({
  validateSearch: (params): { isSettingInitialGooglePassword?: boolean } => {
    return {
      isSettingInitialGooglePassword: !!params.isSettingInitialGooglePassword,
    }
  },
  component: ForgotPasswordPage,
})
